import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "release-notes-header" }
const _hoisted_2 = { class: "d-flex align-items-center flex-wrap gap-2" }
const _hoisted_3 = { class: "badge release-notes-version" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "release-notes-content"
}
const _hoisted_6 = { class: "release-notes-intro" }
const _hoisted_7 = { class: "row g-3" }
const _hoisted_8 = {
  key: 0,
  class: "release-notes-important"
}
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = {
  key: 1,
  class: "alert alert-danger py-2",
  role: "alert"
}
const _hoisted_11 = {
  class: "release-notes-confirmation",
  for: "release-notes-understood"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!

  return (_openBlock(), _createBlock(_component_PrimevueDialog, {
    visible: _ctx.visible,
    modal: true,
    "dismissable-mask": true,
    "close-on-escape": true,
    style: { width: 'min(880px, calc(100vw - 1.5rem))' },
    class: "release-notes-dialog",
    "onUpdate:visible": _ctx.handleVisibilityChange
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "release-notes-header__icon",
          "aria-hidden": "true"
        }, [
          _createElementVNode("i", { class: "fa fa-gift" })
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "mb-0" }, "Nouveautés Suite241", -1)),
            _createElementVNode("span", _hoisted_3, "Version " + _toDisplayString(_ctx.releaseNote?.version), 1)
          ]),
          (_ctx.releaseNote)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, "Mise à jour du " + _toDisplayString(_ctx.formattedReleaseDate), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-secondary btn-sm btn-icon-label",
        disabled: _ctx.isSaving,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("i", {
          class: "fa fa-clock",
          "aria-hidden": "true"
        }, null, -1),
        _createElementVNode("span", { class: "btn-label" }, "Lire plus tard", -1)
      ]))], 8, _hoisted_13),
      _createVNode(_component_AppLoadingButton, {
        type: "button",
        class: "btn btn-primary btn-sm btn-icon-label",
        disabled: !_ctx.understood,
        loading: _ctx.isSaving,
        "loading-label": "Enregistrement...",
        onClick: _ctx.acknowledge
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createElementVNode("i", {
            class: "fa fa-check",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("span", { class: "btn-label" }, "J’ai compris", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.releaseNote)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h6", null, _toDisplayString(_ctx.releaseNote.title), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.releaseNote.summary), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSections, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: section.title,
                  class: _normalizeClass(["col-12", _ctx.visibleSections.length >= 3 ? 'col-lg-4' : 'col-lg-6'])
                }, [
                  _createElementVNode("section", {
                    class: _normalizeClass(["release-notes-section h-100", `release-notes-section--${section.tone}`])
                  }, [
                    _createElementVNode("h6", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa", section.icon]),
                        "aria-hidden": "true"
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(section.title), 1)
                    ]),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                        return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ], 2)
                ], 2))
              }), 128))
            ]),
            (_ctx.releaseNote.important?.length)
              ? (_openBlock(), _createElementBlock("aside", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("strong", null, [
                    _createElementVNode("i", {
                      class: "fa fa-circle-info",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" À retenir")
                  ], -1)),
                  _createElementVNode("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseNote.important, (item) => {
                      return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.saveError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", {
                    class: "fa fa-triangle-exclamation me-1",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.saveError), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                id: "release-notes-understood",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.understood) = $event)),
                class: "form-check-input",
                type: "checkbox",
                disabled: _ctx.isSaving
              }, null, 8, _hoisted_12), [
                [_vModelCheckbox, _ctx.understood]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "J’ai lu et compris les nouveautés de cette version", -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onUpdate:visible"]))
}